export const firebaseConfig = {
  apiKey: "AIzaSyByoHKvjAerWhjINEoTZsLWY4ZhpWdrybM",
  authDomain: "test-chat-a6aaf.firebaseapp.com",
  projectId: "test-chat-a6aaf",
  storageBucket: "test-chat-a6aaf.appspot.com",
  messagingSenderId: "22939607055",
  appId: "1:22939607055:web:d221ee80a642f9d1bc037a",
  measurementId: "G-YQS0ECMG3G",
};
